import headerComponent from '@/components/cust_components/cust_header_component.vue';
import FooterComponent from '@/components/cust_components/cust_footer_component.vue';
import CustPopover from '@/components/cust_components/cust_popover_component.vue';
import LoaderPopover from '@/components/loaderpopover_component.vue';


import moment from 'moment';
import 'moment-timezone';
import Multiselect from 'vue-multiselect';
import 'moment-range';
import cartSlots from './cart_slots.js';

const Moment = require('moment');
const MomentRange = require('moment-range');
const moment_range = MomentRange.extendMoment(Moment)

export default {
    name: 'cartComp',
    components:{
        headerComponent,
        FooterComponent,
        CustPopover,
        LoaderPopover,
        Multiselect
    },
    data(){
        return {
            present_month : '',
            start_date : '',
            last_date : '',
            promo_start_date : '',
            promo_last_date : '',
            Staffoptions: [],
            Staff_selected : {},
            service_details : [],
            selected_service_index : '',
            product_details: [],
            time_slots : [],
            all_staff_time_slots : [],
            noslots_msg : '',
            date_selected : '',
            time_selected : '',
            remove_cart_service : false,
            remove_service_index : '',
            day_slots_not_available : false,
            all_days_active_staff : {},
            all_days_staffs_slots : {},
            unpaid_booking_details : [],
            edit_cart_index : '',
            past_promo_service : false,
        }
    },
    async mounted(){        
        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);
        this.start_date = this.$store.state.temp_start_date;
        this.last_date =  moment(this.start_date, 'YYYY-MM-DD').add(4, "days").format("YYYY-MM-DD");

        // JOYWEB-3135: never carry a slot that has already passed into checkout.
        cartSlots.clear_expired_slots(this.$session);
        this.show_expired_slot_notice();

        if(this.$session.get('service_obj') && JSON.parse(this.$session.get('service_obj')).length > 0){
            this.service_details = JSON.parse(this.$session.get('service_obj'));
            this.selected_service_index = this.service_details.length - 1;
            this.$store.state.total_services_in_cart = this.service_details.length;

            if(this.service_details[this.selected_service_index].is_promo_service == 1){
                this.promo_start_date =  moment(this.service_details[this.selected_service_index].serv_promo_created_date, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD");
                this.promo_last_date =  moment(this.service_details[this.selected_service_index].serv_promo_updated_date, 'YYYY-MM-DD').format("YYYY-MM-DD");
            }
            
            if(this.service_details.some(cart_serv => Object.keys(cart_serv).includes('edit_flag'))){
                let book_staff_id = this.service_details[this.selected_service_index].staff_id; 
                await this.selected_days_data(1, book_staff_id);
                document.querySelectorAll("[class*=edit_btn_]")[this.selected_service_index].hidden = true;
                this.$refs.selectStaffDiv[this.selected_service_index].hidden = true;

                let serv_obj = JSON.parse(this.$session.get('service_obj'));
                delete serv_obj[this.selected_service_index].slot_start_time;
                delete serv_obj[this.selected_service_index].slot_end_time;
                this.$session.set('service_obj', JSON.stringify(serv_obj));
                this.service_details = JSON.parse(this.$session.get('service_obj'));
                if(this.$session.get('product_obj')){
                    this.product_details = JSON.parse(this.$session.get('product_obj'));
                }
                
            }else{
                await this.selected_days_data();
                this.buttons_display();
            }
        }

        if(this.$session.get('product_obj') && JSON.parse(this.$session.get('product_obj')).length > 0){
            this.product_details = JSON.parse(this.$session.get('product_obj'));
            this.$store.state.total_products_in_cart = this.product_details.length;
        }else{
            this.$store.state.total_products_in_cart = 0;
        }

        this.slot_available_check();
       
    },
    methods:{
        
        async slot_available_check(){
            this.$ga.page(this.$router);
            let slots = [];
       
            this.service_details.forEach(function(serv, cart_index){
                if(!serv.edit_flag){
                    if(serv.slot_start_time){
                        slots.push(cartSlots.with_cart_index(serv, cart_index));
                    }
                }
            })

            if(slots.length){
                await this.$store.dispatch('slotsAvailabilityCheck',[this.$store.state.api,slots]);
                let unavailable = cartSlots.unavailable_cart_indexes(this.$store.state.slots_available_details.slots);
                if(unavailable.length){
                    let serv_obj = JSON.parse(this.$session.get('service_obj'));
                    unavailable.forEach(index => {
                        delete serv_obj[index].slot_start_time;
                        delete serv_obj[index].slot_end_time;
                        delete serv_obj[index].slot_date;
                        delete serv_obj[index].staff_id;
                        delete serv_obj[index].staff_name;
                    });
                    this.$session.set('service_obj', JSON.stringify(serv_obj));
                    this.service_details = JSON.parse(this.$session.get('service_obj'));
                }
            }
        },

        async responsive_view(){
            await this.$store.commit('responsive_view', window.innerWidth)
        },

        async selected_days_data(set_staff=0, book_staff_id = 0){

            this.$store.state.loader_popup = true;
              
            await this.getStylistsAvailable(this.service_details[this.selected_service_index].store_id,this.service_details[this.selected_service_index].serv_id, this.start_date); 

            this.all_5_days_slots();

            this.day_active_staff(this.start_date,set_staff);

            if(book_staff_id != 0){
                let staff_exists = this.Staffoptions.find( ({user_id}) => user_id == book_staff_id) 

                if(staff_exists){
                    this.Staff_selected = staff_exists;
                }
                else{
                    this.Staff_selected = this.Staffoptions[0];
                }
            }
          
            this.date_selected = this.start_date;

            if(this.service_details[this.selected_service_index].is_promo_service == 1){
                if( (this.promo_last_date < this.$store.state.temp_start_date) || (this.last_date >= this.promo_last_date) ){
                    this.$refs.next_click[this.selected_service_index].hidden = true;
                }else{
                    this.$refs.next_click[this.selected_service_index].hidden = false;
                }
            }

            if(this.start_date != this.$store.state.temp_start_date){
                this.$refs.back_click[this.selected_service_index].hidden = false;
            }else{
                this.$refs.back_click[this.selected_service_index].hidden = true;
            }

            this.default_day_select();
            
            this.staff_selected_slots(this.Staff_selected);   

            this.$store.state.loader_popup = false;

        },

        check_day_time(slot){
            let slot_time = moment(slot).format('DD-MM-YYYY HH:mm:ss');
            slot_time = moment(slot_time, 'DD-MM-YYYY HH:mm:ss')
            let present_time = moment().tz('Australia/Brisbane').format('DD-MM-YYYY HH:mm:ss');
            present_time  = moment(present_time, 'DD-MM-YYYY hh:mm:ss')
 
            if(slot_time.isAfter(present_time)){
                return slot;
            }
        },

        async all_5_days_slots(){

            this.all_days_active_staff = {};
            this.all_days_staffs_slots = {};

            await this.$store.state.available_stylists.forEach((day)=>{
                this.all_days_active_staff[day.date] = {}
               
                day.staff.forEach((day_each_staff)=>{
                    if(day_each_staff.staff_timings.offline != 1){
                        if(this.service_details.some(cart_serv => Object.keys(cart_serv).includes('edit_flag'))){
                            if(day_each_staff.user_id == this.service_details[this.selected_service_index].staff_id){
                                this.all_days_active_staff[day.date][day_each_staff.user_id] = day_each_staff;
                            }
                        }else{
                            this.all_days_active_staff[day.date][day_each_staff.user_id] = day_each_staff;
                        }
                    } 
                   
                })
                
                this.all_days_staffs_slots[day.date] = {}
                this.all_days_staffs_slots[day.date][null] = []
                let null_day = this.all_days_staffs_slots[day.date][null]

                let day_allstaff_slots = [];

                if(this.service_details[this.selected_service_index].is_promo_service == 1){
                    if(moment(day.date).isBetween(this.promo_start_date, this.promo_last_date, undefined,  '[]')){
                        day_allstaff_slots = this.day_slots(day.store_business_hours.open_time, day.store_business_hours.close_time, this.service_details[this.selected_service_index], this.all_days_active_staff[day.date], day.date);
                    }
                }else{
                    day_allstaff_slots = this.day_slots(day.store_business_hours.open_time, day.store_business_hours.close_time, this.service_details[this.selected_service_index], this.all_days_active_staff[day.date], day.date);
                }

                if(day_allstaff_slots){
                    day_allstaff_slots.forEach((staff_slots)=>{

                        if(day.date == this.$store.state.temp_start_date){
                            staff_slots.time_slots = staff_slots.time_slots.filter(this.check_day_time);
                        }

                        staff_slots.time_slots.forEach((slot) => {
                            let slot_format_array = null_day.map(m => m.format('hh:mm A'))
                            
                            if (!slot_format_array.includes(slot.format('hh:mm A'))) {
                                null_day.push(slot);
                            }
                        });
    
                        null_day =  null_day.sort((a, b) => {
                            return moment(a).diff(b);
                        });

                        this.all_days_staffs_slots[day.date][staff_slots.staff_id] = staff_slots.time_slots;
                    })
                }
                
            })

            for (let [date, day_staff_slots] of Object.entries(this.all_days_staffs_slots)) {
                let count = Object.values(day_staff_slots).reduce((sum, current) => sum + current.length, 0);
                let day_div = document.querySelectorAll("[data-date='"+ date +"']")[this.selected_service_index];
                day_div.style = "";
                if(count == 0){
                    day_div.style.pointerEvents = "none";
                    day_div.style.color = "#7C8495";
                    day_div.style.borderColor = "#C6C6C6";
                    day_div.style.background = "#EBEFF2";

                    if(date == this.start_date){
                        //document.getElementsByClassName("day_div_"+ this.selected_service_index)[0].className = "day_div_"+this.selected_service_index;
                    }      
                }
            }

        },

        select_following_active_day(){
           
            let next_selected_date = moment(this.date_selected , "YYYY-MM-DD").add(1,"days");
            this.date_selected = next_selected_date.format("YYYY-MM-DD")
        
            if(next_selected_date != moment(this.last_date)){
                let next_day_slot_count = this.all_days_staffs_slots[this.date_selected]
                
                if(next_day_slot_count == undefined){
                    this.next_days()
                }
                else if (next_day_slot_count[null].length == 0){
                    this.select_following_active_day()
                }
                else{

                    this.day_active_staff(this.date_selected);

                    let all_dates_stylist = this.$store.state.available_stylists
                    all_dates_stylist.forEach((day) => {
                        if(day.date == this.date_selected){
                            this.service_details[this.selected_service_index].slot_date = day.date;
                        }
                    })
        
                    this.staff_selected_slots(this.Staffoptions[0]);


                    document.querySelectorAll("[data-date='"+ this.date_selected +"']")[this.selected_service_index].className +=  " selected_day_div";
                    document.getElementsByClassName("day_div_"+ this.selected_service_index)[0].className = "day_div_"+this.selected_service_index;
                }

            }
           
        },

        async getStylistsAvailable(store_id, serv_id, start_date){

            await this.$store.dispatch('getServiceAvaibleStylists',[this.$store.state.api, 
                store_id, serv_id,start_date, this.last_date]
            );

            let last_date_month = moment(this.last_date,'YYYY-MM-DD' ).format('MMM');
            let start_date_month = moment(start_date,'YYYY-MM-DD' ).format('MMM');

            if(last_date_month == start_date_month){
                this.present_month = moment(start_date,'YYYY-MM-DD' ).format('MMM YYYY');
            }
            else{
                this.present_month = moment(start_date,'YYYY-MM-DD' ).format('MMM YYYY') + " to " +  moment(this.last_date,'YYYY-MM-DD' ).format('MMM YYYY');
            }
            
        },

        default_day_select(){

            document.getElementsByClassName("day_div_" +this.selected_service_index).forEach((date_div) => {
                date_div.className = "day_div_"+this.selected_service_index;
            })

            document.getElementsByClassName("day_div_"+ this.selected_service_index)[0].className += " selected_day_div";

            let timediv = document.getElementsByClassName('time_div')

            timediv.forEach((slot_div)=>{
                slot_div.className = 'time_div';
            })
        },

        buttons_display(){
           
            this.$refs.staffSelectedDiv[this.selected_service_index].hidden = true;
            this.$refs.editDiv[this.selected_service_index].hidden = false;
            document.querySelectorAll("[class*=close_btn_]")[this.selected_service_index].hidden = false;
            document.querySelectorAll("[class*=edit_btn_]")[this.selected_service_index].hidden = true;
            document.querySelectorAll("[class*=remove_btn_]")[this.selected_service_index].hidden = false;

            this.service_details.forEach((cart_service,index)=>{
               
                if(this.selected_service_index != index){
                    this.$refs.staffSelectedDiv[index].hidden = false;
                    this.$refs.editDiv[index].hidden = true;
                    document.querySelectorAll("[class*=close_btn_]")[index].hidden = true;
                    document.querySelectorAll("[class*=edit_btn_]")[index].hidden = false;
                    document.querySelectorAll("[class*=remove_btn_]")[index].hidden = true;
                }else if(this.selected_service_index == index){
                    if(cart_service.slot_start_time){
                        this.$refs.staffSelectedDiv[index].hidden = false;
                        this.$refs.editDiv[index].hidden = true;
                        document.querySelectorAll("[class*=close_btn_]")[index].hidden = true;
                        document.querySelectorAll("[class*=edit_btn_]")[index].hidden = false;
                        document.querySelectorAll("[class*=remove_btn_]")[index].hidden = true;

                        let serv_obj = JSON.parse(this.$session.get('service_obj'));
                        this.service_details[this.selected_service_index].slot_date = serv_obj[this.selected_service_index].slot_date
                    }
                }
                
            })
        },

        day_slots(open_time,close_time,serv_details, allStaff, date){

            let serv_dur = serv_details.serv_defdur + serv_details.serv_postbuffertime + serv_details.serv_prebuffertime;

            let serv_dur_without_postbuffer = serv_details.serv_defdur + serv_details.serv_prebuffertime;
            
            // dont delete
            // const day_start = moment(open_time, 'HH:mm:ss' );
            // const day_end   = moment(close_time, 'HH:mm:ss');
            // const day = moment_range.range(day_start, day_end);

            this.all_staff_time_slots = [];

            let date_cart_services = [];
            let cart_services = JSON.parse(this.$session.get('service_obj'));
        
            cart_services.splice(this.selected_service_index,1);

            cart_services.forEach((cart_service) => {
                if(cart_service.slot_date == date){
                    date_cart_services.push(cart_service)
                } 
            })
            
            for (let [staff_id, staff_details] of Object.entries(allStaff)) {
                
                let single_staff_slots =  {};

                let break_ranges = [];

                let booking_ranges = [];

                single_staff_slots.staff_id = staff_id;

                let staff_open_time =  moment(staff_details.staff_timings.open_time, 'HH:mm:ss' );
          
                let staff_close_time =  " "

                if(staff_details.staff_timings.offline == 2){
                    staff_open_time =  moment("00:00:00", 'HH:mm:ss' );
                    staff_close_time =  moment("24:00:00", 'HH:mm:ss' );
                }else{
                    if(staff_details.staff_timings.close_time == "00:00:00"){
                        staff_close_time =  moment("24:00:00", 'HH:mm:ss' );
                    }
                    else{
                        staff_close_time =  moment(staff_details.staff_timings.close_time, 'HH:mm:ss' );
                    }
                }
            
                let staff_range =  moment_range.range(staff_open_time, staff_close_time)

                let staff_intersect_day = [];

                // dont delete
                // let store_staff_intersect_end_time = day.intersect(staff_range);

                // if(day.intersect(staff_range) != null){
                //     staff_intersect_day.push(day.intersect(staff_range));
                // }

                let store_staff_intersect_end_time = staff_range;

                if(staff_range != null){
                    staff_intersect_day.push(staff_range);
                }

                date_cart_services.forEach((cart_service)=>{
                    let cart_staff_booking = {};
                    
                    cart_staff_booking.book_start_date = cart_service.slot_date;
                    cart_staff_booking.end_time_with_buffer = moment(cart_service.slot_end_time, "HH:mm:ss").add(cart_service.serv_postbuffertime,'minutes').format("HH:mm:ss");
                    cart_staff_booking.is_break = 0;
                    cart_staff_booking.serv_postbuffertime = cart_service.serv_postbuffertime;
                    cart_staff_booking.serv_prebuffertime = cart_service.serv_prebuffertime;
                    cart_staff_booking.start_time_with_buffer = moment(cart_service.slot_start_time, "HH:mm:ss").subtract(cart_service.serv_prebuffertime,'minutes').format("HH:mm:ss");
                

                    staff_details.staff_bookings.push(cart_staff_booking);
                })

                staff_details.staff_bookings.forEach((staff_booking)=>{

                    let book_start_time = moment(staff_booking.start_time_with_buffer, "HH:mm:ss");
                    let book_end_time = moment(staff_booking.end_time_with_buffer, "HH:mm:ss");

                    let book_range =  moment_range.range(book_start_time, book_end_time);
                    
                    let each_range_intersection = []
                    
                    staff_intersect_day.forEach((each_range)=>{
                        each_range_intersection = each_range_intersection.concat(each_range.subtract(book_range))
                    })
                    staff_intersect_day = each_range_intersection

                    if(staff_booking.is_break == 1){
                        break_ranges.push(book_range);
                    }else{
                        booking_ranges.push(book_range);
                    }

                })
                let staff_intersect_slots = []
                    
                staff_intersect_day.forEach((each_range)=>{
                    if(each_range != null){
                        let time_ranges = Array.from(each_range.by('minutes', { step:serv_dur }));
                    
                        let range_last_slot_without_post_dur = moment(time_ranges[time_ranges.length - 1], "hh:mm A").add(serv_dur_without_postbuffer, 'minutes');
                        let last_slot_range_without_post_buffer =  moment_range.range(moment(time_ranges[time_ranges.length - 1]), range_last_slot_without_post_dur);

                        let range_last_slot_with_buffers = moment(time_ranges[time_ranges.length - 1], "hh:mm A").add(serv_dur, 'minutes');
                        let last_slot_range_with_buffers =  moment_range.range(moment(time_ranges[time_ranges.length - 1]), range_last_slot_with_buffers);
                        let book_intersects_break = false;
                      
                        if(range_last_slot_without_post_dur.isAfter(each_range.end)){
                            if(break_ranges.length > 0){
                                break_ranges.forEach((break_range) =>{
                                    if(last_slot_range_without_post_buffer.overlaps(break_range)){
                                        if((last_slot_range_without_post_buffer.overlaps(break_range, { adjacent: true }))){
                                            book_intersects_break = true;
                                            return;
                                        }
                                    }
                                })
                            }

                            let  book_intersect_bookings = false;

                            if(booking_ranges.length > 0 && book_intersects_break == false){
                                booking_ranges.forEach((booking_range) =>{      
                                    if(last_slot_range_without_post_buffer.overlaps(booking_range)){
                                        book_intersect_bookings= true;
                                        return;
                                    }
                                })
                            }
                            if(book_intersect_bookings || book_intersects_break){
                                time_ranges.pop();  
                            }
                        }else if(range_last_slot_with_buffers.isAfter(each_range.end)){

                            let slot_post_buffer_range = last_slot_range_with_buffers.subtract(last_slot_range_without_post_buffer);
                            let overlaps_with_booking = false;

                            let slot_start_time = moment(slot_post_buffer_range[0].start, "HH:mm:ss").format("HH:mm:ss");
                            let slot_end_time = moment(slot_post_buffer_range[0].end, "HH:mm:ss").format("HH:mm:ss");

                            slot_start_time = moment(slot_start_time, "HH:mm:ss");
                            slot_end_time = moment(slot_end_time, "HH:mm:ss");

                            slot_post_buffer_range = moment_range.range(slot_start_time,slot_end_time);
                           
                            if(booking_ranges.length > 0){    
                                booking_ranges.forEach((booking_range) =>{
                                    if(booking_range.intersect(slot_post_buffer_range) != null){
                                        overlaps_with_booking = true;
                                        return;
                                    }
                                })
                            } 

                            if(overlaps_with_booking){
                                time_ranges.pop();
                            }

                        }
                    
                        let range_last_slot_with_dur = moment(time_ranges[time_ranges.length - 1], "hh:mm A").add(serv_dur, 'minutes');
                        
                        if(each_range.end.format("hh:mm A") == store_staff_intersect_end_time.end.format("hh:mm A")){
                            if(range_last_slot_without_post_dur.isAfter(store_staff_intersect_end_time.end)){
                                time_ranges.pop();
                            }
                        }else{
                            if(range_last_slot_with_dur.isAfter(each_range.end)){
                                break_ranges.forEach((break_range) =>{
                                    if(break_range == each_range){
                                        time_ranges.pop();
                                    }
                                }) 
                            }
                        }

                        staff_intersect_slots = staff_intersect_slots.concat(time_ranges);
                    }
                    
                })

                single_staff_slots.time_slots = staff_intersect_slots;

                this.all_staff_time_slots.push(single_staff_slots)  
            }

            return this.all_staff_time_slots;
        },

        staff_selected_slots(staff_details){
            
            if(this.all_days_staffs_slots[this.date_selected][staff_details.user_id]){
                this.time_slots = this.all_days_staffs_slots[this.date_selected][staff_details.user_id];
            }else{
                this.time_slots = []
            }
           
            if(this.service_details[this.selected_service_index].serv_prebuffertime > 0){
                let time_slots_adding_prebuffer = []
                this.time_slots.forEach((time_slot)=>{
                    time_slot = moment(time_slot, "hh:mm:ss").add(this.service_details[this.selected_service_index].serv_prebuffertime, 'minutes');
                    time_slots_adding_prebuffer.push(time_slot)
                })
                this.time_slots = time_slots_adding_prebuffer;
            }

            let timediv = document.getElementsByClassName('time_div');

            timediv.forEach((slot_div)=>{
                slot_div.className = 'time_div';
            })

           
            if(this.all_days_staffs_slots[this.date_selected][null] == 0){
                this.noslots_msg = "There are no slots available on this day."
                this.day_slots_not_available = true;
                this.past_promo_service = false;
            }else{
                this.noslots_msg = "There are no slots available for this staff, select another staff.";
                this.day_slots_not_available = false; 
                this.past_promo_service = false;
            }

            let selected_staff_details = this.$store.state.available_stylists.find(dates => dates.date == this.date_selected).staff.find(staffs => staffs.user_id == this.service_details[this.selected_service_index].staff_id);

            if( ((this.service_details[this.selected_service_index].is_promo_service == 1) && (moment().diff(this.promo_last_date, 'day') > 0)) || 
            ((this.all_days_staffs_slots[this.date_selected][this.service_details[this.selected_service_index].staff_id] === undefined) && (this.service_details[this.selected_service_index].is_promo_service == 1) && (moment().diff(this.promo_last_date, 'day') > 0)) || 
            ((this.all_days_staffs_slots[this.date_selected][this.service_details[this.selected_service_index].staff_id] === undefined) && this.service_details[this.selected_service_index].edit_flag == 1 && this.service_details[this.selected_service_index].is_promo_service == 0 && selected_staff_details == undefined) || 
            ((this.all_days_staffs_slots[this.date_selected][this.service_details[this.selected_service_index].staff_id] === undefined) && this.service_details[this.selected_service_index].edit_flag == 1 && this.service_details[this.selected_service_index].is_promo_service == 1 && selected_staff_details == undefined) ){
                this.noslots_msg = "Selected staff is not available on that  service in upcoming days. Please contact salon if you want to reschedule."
                this.day_slots_not_available = false;
                this.past_promo_service = true;
                this.$refs.next_click[this.selected_service_index].hidden = true;
            }

            this.time_selected = "";

            return this.time_slots; 

        },

        date_select(e,date,index){
            delete this.service_details[this.selected_service_index].slot_start_time;
            delete this.service_details[this.selected_service_index].slot_end_time;

            this.time_selected = "";
            document.querySelectorAll("[class*=time_slot_div_]")[this.selected_service_index].style.border = ""

            let timediv = document.querySelectorAll("[class*=time_slot_div_]")[this.selected_service_index].querySelectorAll('.time_div');

            timediv.forEach((slot_div)=>{
                slot_div.className = 'time_div';
            })
            
            let all_day_div = this.$refs.dates_div[this.selected_service_index].children;

            all_day_div.forEach((day_div) => {  
                day_div.className = 'day_div_'+index;
            })

            e.currentTarget.className += " selected_day_div"; 

            this.date_selected = e.currentTarget.dataset.date;

            this.day_active_staff(date);
            
            let all_dates_stylist = this.$store.state.available_stylists;
            all_dates_stylist.forEach((day) => {
                if(day.date == e.currentTarget.dataset.date){
                    this.service_details[this.selected_service_index].slot_date = day.date;
                }
            })

            this.staff_selected_slots(this.Staffoptions[0]);
          
        },

        slot_select(e, serv_index){

            // JOYWEB-3078: scope the selection to the service actually clicked. Previously this used
            // the stale this.selected_service_index and an ordinal NodeList index, so in a multi-
            // service cart clicking a slot cleared the WRONG service's container — multiple time
            // slots stayed highlighted with no way to deselect. Now the clicked serv_index drives it,
            // and we target that service's slot container directly by its class.
            if (serv_index !== undefined && serv_index !== null && serv_index !== '') {
                this.selected_service_index = serv_index;
            }
            let slot_container = document.querySelector('.time_slot_div_' + this.selected_service_index)
            let timediv = slot_container ? slot_container.querySelectorAll('.time_div') : []

            if(e){
                this.time_selected = e.currentTarget.dataset.time;

                timediv.forEach((slot_div)=>{
                    slot_div.className = 'time_div';
                })

                e.currentTarget.className  += " selected_time_div"

                if (slot_container) { slot_container.style.border = "" }

                this.service_details[this.selected_service_index].slot_start_time = moment(e.currentTarget.dataset.time);

                let end_time = moment(e.currentTarget.dataset.time).add(this.service_details[this.selected_service_index].serv_defdur , "minutes");
                this.service_details[this.selected_service_index].slot_end_time = moment(end_time);

                this.$forceUpdate();

                this.save_timings(this.selected_service_index);
            }else{
                let booked_time = this.service_details[this.selected_service_index].slot_start_time;
                timediv.forEach((time_slot)=>{
                    let slottime = moment(time_slot.dataset.time).format("HH:mm:ss");
                    
                    if(slottime == booked_time){
                        this.time_selected = time_slot.dataset.time;
                        time_slot.className += ' selected_time_div';
                    }
                })

            }
            
        },

        day_active_staff(selected_date){
               
            this.Staffoptions = Object.values(this.all_days_active_staff[selected_date]);
        
            this.Staffoptions.sort(function (a, b) {
                return a.user_staff_order - b.user_staff_order;
            });

            this.Staffoptions.unshift({user_first_name: "Any Staff",user_id: null});

            this.Staff_selected = this.Staffoptions[0];
            
        },

        async next_days(){
            this.time_selected = "";
            this.start_date  = moment(this.last_date, '"YYYY-MM-DD"').add(1, "days").format("YYYY-MM-DD");
            this.last_date = moment( this.start_date, '"YYYY-MM-DD"').add(4, "days").format("YYYY-MM-DD");
            this.selected_days_data();
        },

        async previous_days(){   
            this.time_selected = "";
            this.last_date  = moment(this.start_date, 'YYYY-MM-DD').subtract(1, "days").format("YYYY-MM-DD");
            this.start_date = moment(this.last_date, 'YYYY-MM-DD').subtract(4, "days").format("YYYY-MM-DD");

            if(moment().diff(this.start_date, 'day') > 0){
                this.start_date = this.$store.state.temp_start_date;
                this.last_date = moment( this.start_date, '"YYYY-MM-DD"').add(4, "days").format("YYYY-MM-DD");
            }

            this.selected_days_data();
        },

        edit_slots_div_display(flag){

            let serv_obj = JSON.parse(this.$session.get('service_obj'));

            if(flag == 0){
               
                if(!this.time_selected){
                    if(serv_obj[this.selected_service_index].slot_start_time){
                        this.service_details[this.selected_service_index].slot_date = serv_obj[this.selected_service_index].slot_date;
                        this.service_details[this.selected_service_index].slot_start_time = serv_obj[this.selected_service_index].slot_start_time;
                        this.service_details[this.selected_service_index].slot_end_time = serv_obj[this.selected_service_index].slot_end_time;
                    }
                }

                this.$refs.editDiv.forEach((edit_div)=>{
                    edit_div.hidden = true;
                })
    
                this.$refs.staffSelectedDiv.forEach((staff_select_div)=>{
                    staff_select_div.hidden = false;
                })

                document.querySelectorAll("[class*=close_btn_]")[this.selected_service_index].hidden = true;
                document.querySelectorAll("[class*=edit_btn_]")[this.selected_service_index].hidden = false;
                document.querySelectorAll("[class*=remove_btn_]")[this.selected_service_index].hidden = true;
                
                this.selected_service_index = "";
            }
            else{
                this.$refs.editDiv.forEach((edit_div)=>{
                    edit_div.hidden = true;
                })
    
                this.$refs.staffSelectedDiv.forEach((staff_select_div)=>{
                    staff_select_div.hidden = false;
                })

                document.querySelectorAll("[class*=remove_btn_]").forEach((remove_btn)=>{
                    remove_btn.hidden = true;
                })

                document.querySelectorAll("[class*=close_btn_]").forEach((save_btn)=>{
                    save_btn.hidden = true;
                })
    
                document.querySelectorAll("[class*=edit_btn_]").forEach((edit_btn)=>{
                    edit_btn.hidden = false;
                })
            }
          
        },
       
        async edit_timings(index){

            this.edit_slots_div_display(1);

            this.$refs.editDiv[index].hidden = false;
            this.$refs.staffSelectedDiv[index].hidden = true;
            document.querySelectorAll("[class*=close_btn_]")[index].hidden = false;
            document.querySelectorAll("[class*=edit_btn_]")[index].hidden = true;
            document.querySelectorAll("[class*=remove_btn_]")[index].hidden = false;
            this.selected_service_index = index;

            let serv_obj = JSON.parse(this.$session.get('service_obj'));

            if(this.service_details[index].is_promo_service == 1){
                this.promo_start_date =  moment(this.service_details[index].serv_promo_created_date, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD");
                this.promo_last_date =  moment(this.service_details[index].serv_promo_updated_date, 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            if(serv_obj[index].slot_date  || this.service_details[index].slot_date){
                this.start_date = this.date_selected = this.service_details[index].slot_date;
            }else{
                this.start_date  = moment(new Date(), 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD");
            }
            
            this.last_date = moment(this.start_date, '"YYYY-MM-DD"').add(4, "days").format("YYYY-MM-DD");

            let book_staff_id = this.service_details[this.selected_service_index].staff_id; 

            await this.selected_days_data(1, book_staff_id);

            this.slot_select();

            this.card_scroll();
        },

        async save_timings(index){
                
            if(this.Staff_selected.user_id == null) {

                let format_time_selected = moment(this.time_selected);

                for(const [staff_id, time_slots] of Object.entries(this.all_days_staffs_slots[this.date_selected])){

                    if (staff_id != null){

                        for (const slot of time_slots){

                            if(this.service_details[this.selected_service_index].serv_prebuffertime > 0){
                                let time_selected_with_prebuffer = moment(this.time_selected).subtract(this.service_details[this.selected_service_index].serv_prebuffertime, 'minutes');
                                format_time_selected = moment(time_selected_with_prebuffer);
                            }

                            if(slot.toLocaleString() == format_time_selected.toLocaleString()){
                                this.Staff_selected = this.Staffoptions.find( ({user_id}) => user_id == staff_id) ;
                                break;
                            }
                        }
                    } 
                    
                    if(this.Staff_selected.user_id != null){
                        break;
                    }
                }
            }

            if(this.Staff_selected.user_id != null){
                let serv_obj = JSON.parse(this.$session.get('service_obj'));
                serv_obj[index].staff_id = this.Staff_selected.user_id;
                serv_obj[index].user_perm_staff_type = this.Staff_selected.user_perm_staff_type;
                serv_obj[index].staff_name = this.Staff_selected.user_first_name;
                serv_obj[index].slot_date = this.date_selected;
                serv_obj[index].slot_start_time = moment(this.time_selected).format("HH:mm:ss");
                serv_obj[index].slot_end_time = moment(this.time_selected).add(serv_obj[index].serv_defdur,'minutes').format("HH:mm:ss");
                this.$session.set('service_obj', JSON.stringify(serv_obj));
                this.service_details = JSON.parse(this.$session.get('service_obj'));

                await this.staff_selected_slots(this.Staff_selected); 
                this.slot_select();
            }

        },

        remove_service_popup(index){
            this.remove_cart_service = true;
            this.remove_service_index = index; 
        },

        remove_service(){
            let serv_obj = JSON.parse(this.$session.get('service_obj'));
            serv_obj.splice(this.remove_service_index, 1);
            this.$session.set('service_obj', JSON.stringify(serv_obj));
            this.service_details = JSON.parse(this.$session.get('service_obj'));
            this.remove_cart_service = false;
            this.$store.state.total_services_in_cart = this.service_details.length;
            this.edit_slots_div_display(1);
        },

        show_expired_slot_notice(){
            if(!this.$session.get(cartSlots.EXPIRED_NOTICE_KEY)) return;
            this.$session.remove(cartSlots.EXPIRED_NOTICE_KEY);
            this.$bvToast.toast("Your previously selected appointment time has passed. Please choose a new time.", {
                title: "Please choose a new time",
                variant: 'danger',
                autoHideDelay: 6000,
                solid: true
            })
        },

        card_scroll(){
            let element_top = document.querySelectorAll("[class*=service_card_]")[this.selected_service_index].offsetTop - 60;
            window.scroll({ top: element_top});
            if(!this.time_selected){
                var title = "Oops! You missed something."
                var message =  "Please select a time slot."
                this.$bvToast.toast(`${message}`, {
                    title: `${title}`,
                    variant: 'danger',
                    autoHideDelay: 3000,
                    solid: true
                })
            } 
        },

        remove_service_pop_close(){
            this.remove_cart_service = false;
        },

        async cart_continue(){
           
            let serv_obj = JSON.parse(this.$session.get('service_obj'));
            let all_services_slots_selected = serv_obj.every(cart_serv => Object.keys(cart_serv).includes('slot_start_time'));

            let card_close = Array.from(document.querySelectorAll("[class*=close_btn_]")).every(card_btn => card_btn.hasAttribute('hidden'));

            if(!this.service_details.some(cart_serv => Object.keys(cart_serv).includes('edit_flag'))){
                if(all_services_slots_selected){
                    await this.$store.dispatch('getProducts',[this.$store.state.api,JSON.parse(this.$session.get('store_details')).store_id,1]);
                    if(!card_close){
                        if(!this.time_selected){
                            document.querySelectorAll("[class*=time_slot_div_]")[this.selected_service_index].style.border = "2px solid #D00000";
                            this.card_scroll();
                        }else{
                            if( this.$store.state.products_list.length == 0){
                                this.$router.push('/previewbooking');
                            }else{
                                this.$router.push('/addproducts');
                            }
                        }
                    }else{
                        if( this.$store.state.products_list.length == 0){
                            this.$router.push('/previewbooking');
                        }else{
                            this.$router.push('/addproducts');
                        }
                    }
                }
                else{
                    if(!card_close){
                        if(!this.time_selected){
                            document.querySelectorAll("[class*=time_slot_div_]")[this.selected_service_index].style.border = "2px solid #D00000";
                            this.card_scroll();
                        }
                        else{
                            this.edit_slots_div_display(0);
                            this.cart_continue();
                        }
                    }else{
                        this.edit_cart_index = serv_obj.findIndex(cart_serv => !cart_serv.slot_start_time);
                        if(this.edit_cart_index >= 0){
                            this.edit_timings(this.edit_cart_index);
                            document.querySelectorAll("[class*=time_slot_div_]")[this.selected_service_index].style.border = "2px solid #D00000";
                        }
                    }
                }
            }else{
                if(!this.time_selected){
                    if(this.time_slots.length){
                        document.querySelectorAll("[class*=time_slot_div_]")[this.selected_service_index].style.border = "2px solid #D00000";
                    }else{
                        this.select_following_active_day();
                        document.querySelectorAll("[class*=time_slot_div_]")[this.selected_service_index].style.border = "2px solid #D00000";
                    }
                    this.card_scroll();
                }
                else{
                    this.$router.push('/previewbooking');
                }   
            }
            
        },

        addNewServices(){

            if(this.$session.get('service_obj')){
                let serv_obj = JSON.parse(this.$session.get('service_obj'));
                let all_services_slots_selected = serv_obj.every(cart_serv => Object.keys(cart_serv).includes('slot_start_time'));

                if(all_services_slots_selected){
                    this.$router.push('/home/'+ this.$store.state.store_url_name)
                }else{
                    this.edit_cart_index = serv_obj.findIndex(cart_serv => !cart_serv.slot_start_time);
                    if(this.edit_cart_index >= 0){
                        this.edit_timings(this.edit_cart_index);
                        document.querySelectorAll("[class*=time_slot_div_]")[this.selected_service_index].style.border = "2px solid #D00000";
                        this.card_scroll();
                    }
                }
            }
            else{
                this.$router.push('/home/'+ this.$store.state.store_url_name);
            }
            
        },

        product_redirection(){
            this.$router.push('/addproducts');
        }
    },
    filters:{
        week_day(date){
            return moment(date).format('ddd');
        },
        date_number(date){
            return moment(date).format('DD');
        },
        book_date_format(date){
            return moment(date, "YYYY-MM-DD").format('ddd, MMM DD, YYYY');
        },
        slot_format(date){
            return moment(date).format("hh:mm A");
        },
        format_12_hr(date){
            return moment(date, "hh:mm A").format("hh:mm A")
        }
    }

}